<template>
  <div class="container-fluid px-md-4">
    <div class="panel-heading my-2">
      <h2 class="text-left">Role Claims Management</h2>
    </div>
    <form class="needs-validation pt-1 my-2" @submit.prevent="getRoleClaims">
      <div class="form-group row mx-0 justify-content-between m-0" :style="{ marginBottom: '1rem' }">
        <div class="mx-3 my-1">
        <label class=" col-form-label mr-3">Role</label>

          <dropdownlist
            class="my-2"
            ref="roleDropdown"
            :data-items="roles"
            :text-field="'roleName'"
            :data-item-key="'roleID'"
            @change="onRoleSelect"
          >
          </dropdownlist>
          <button
            type="submit"
            value="Search"
            class="k-button k-secondary mx-4 py-1"
          >
            <i class="fa fa-search" aria-hidden="true"></i> Search
          </button>
        </div>
        <div class="my-auto mx-auto mx-sm-2">
          <button
              title="Add new"
              class="k-button k-secondary"
              @click="insert"
              type="button"
            >
              <i class="fa fa-plus mr-2" aria-hidden="true"></i>

              Add new
          </button>
        </div>
      </div>
    </form>
    <div class="example-wrapper" v-if="roleClaims">
      <Grid
        ref="grid"
        :style="{ height: '440px' }"
        :pageable="true"
        :skip= "skip"
        :data-items="result"
        :columns="columns"
        :take="take"
        :total="total"
        @pagechange="pageChangeHandler"
      >
        <template v-slot:myTemplate="{ props }">
          <custom :data-item="props.dataItem" @edit="edit" @remove="remove" />
        </template>
        <grid-norecords> There is no data available custom </grid-norecords>
      </Grid>
      <dialog-container
        v-if="roleClaimInEdit"
        :dialog-title="dialogTitle"
        :data-item="roleClaimInEdit"
        @save="save"
        @cancel="cancel"
      >
      </dialog-container>
    </div>
  </div>
</template>
<script>
import { Grid, GridToolbar, GridNoRecords } from "@progress/kendo-vue-grid";
import { sampleroleClaims } from "./data";
import DialogContainer from "./DialogContainer";
import CommandCell from "./CommandCell";
import axios from "axios";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { oidcSettings } from "../../services/store";

export default {
  components: {
    Grid: Grid,
    "grid-toolbar": GridToolbar,
    "grid-norecords": GridNoRecords,
    "dialog-container": DialogContainer,
    custom: CommandCell,
    dropdownlist: DropDownList,
  }, 
  props: {
    identity: {
      type: Object,
      default: null,
    }
  },
  data: function () {
    return {
      base_url: undefined,

      sort: [{ field: "claimType", dir: "asc" }],
      roleClaims: undefined, //sampleroleClaims,
      roles: [],
      events: [],
      identityPools: [],     
      skip: 0,
      take: 10,
      selectedRole: undefined,
      selectedIdentity: undefined,
      tempRole:undefined,
      tempIdentity: this.identity,
      roleClaimInEdit: undefined,
      columns: [
        { field: "claimType", title: "Claim Type" },
        {
          field: "claimValue",
          editable: false,
          title: "Claim Value",
        },

        { cell: "myTemplate", width: "150px" },
      ],
    };
  },
  computed: {
    dialogTitle() {
      return `${
        this.roleClaimInEdit.claimType === undefined ? "Add" : "Edit"
      } Role Claim`;
    },
    result: {
            get: function() {
                return this.roleClaims.slice(this.skip, this.take + this.skip);
            }
        },
    total () {
        return this.roleClaims ? this.roleClaims.length : 0;
    }
  },
  beforeMount: function () {
    this.base_url = oidcSettings.authority + "/api/IdentityManagement/";
    if(this.tempIdentity!=null)
    {
      this.getRoles();
    }
  },
  watch:{
    identity:function(){
      this.tempIdentity=this.identity;
      this.tempRole = undefined;
      this.$refs.roleDropdown.currentValue = null;
     this.getRoles();
    }
  },
  methods: {
     pageChangeHandler: function(event) {
        this.skip = event.page.skip;
        this.take = event.page.take;
  },
    async getIdentityPools() {
      try {
        const response = await axios.get(
          this.base_url + "IdentityPool/GetIdentityPools"
        );
        this.identityPools = response.data.result;
      } catch (err) {
        console.log(err);
      }
    },
    async getRoles() {
      try {
        const client_id = oidcSettings.client_id;

        const response = await axios.get(
          this.base_url + "Role/GetRoles/"+this.tempIdentity.id,
        );
        this.roles = response.data.result;
      } catch (err) {
        console.log(err);
      }
    },
    async getRoleClaims() {
      if (!this.tempRole) return;
      this.selectedIdentity=this.tempIdentity;
      this.selectedRole=this.tempRole;
      try {
        const response = await axios.get(
          this.base_url + "RoleClaim/GetRoleClaims/"+this.selectedRole.roleID+"/"+this.selectedIdentity.id,
        );
        this.roleClaims = response.data.result;
      } catch (err) {
        console.log(err);
      }
    },
    onSelectIdentity(event) {
      console.log("change", event.target.value);
      this.tempIdentity=event.target.value;
      this.tempRole = undefined;
      this.$refs.roleDropdown.currentValue = null;
      this.getRoles();
    },
    edit(dataItem) {
      this.roleClaimInEdit = this.cloneProduct(dataItem);
    },
    async remove(dataItem) {
      try {
        const response = await axios.delete(
          this.base_url + "RoleClaim/DeleteRoleClaim/"+this.selectedRole.roleID+"/"+this.selectedIdentity.id+"/"+ dataItem.claimType,
        );
        console.log(response.data.message);
        this.roleClaims = this.roleClaims.filter(
          (p) => p.claimType !== dataItem.claimType
        );
      } catch (err) {
        console.log(err);
      }
    },
    onRoleSelect(event) {
      console.log("change", event.target.value);
      //this should be moved to on submit
      this.tempRole = event.target.value;
    },
    async addRoleClaim(dataItem) {
      let data = {
        value: dataItem.claimValue,
        type: dataItem.claimType,
      };
      try {
        const response = await axios
          .post(this.base_url + "RoleClaim/AddRoleClaim/"+this.selectedRole.roleID+"/"+this.selectedIdentity.id, [data])
          .then((response) => {
            this.status = response.data.status;
            this.responseMsg = response.data.message;
            console.log(this.responseMsg);
            this.roleClaims.push(data);
          });

        this.getRoleClaims();
      } catch (err) {
        console.log("Ooops!" + err);
      }
    },
    async editRoleClaim(dataItem) {
      let data = {
        value: dataItem.claimValue,
        type: dataItem.claimType,
        roleID: this.selectedRole.roleID,
      };
      try {
        const response = await axios.put(
          this.base_url + "RoleClaim/UpdateRoleClaim/"+this.selectedRole.roleID+"/"+this.selectedIdentity.id,
          data, 
        );
        this.status = response.data.status;
        this.responseMsg = response.data.message;
        console.log(this.responseMsg);
        this.showMsg = true;
        this.dataItem = {};
        const index = this.roleClaims.findIndex(
          (p) => p.claimType === dataItem.claimType
        );
        this.roleClaims.splice(index, 1, dataItem);
      } catch (err) {
        console.log("Ooops!" + err);
      }
    },
    save() {
      const dataItem = this.roleClaimInEdit;
      const roleClaims = this.roleClaims.slice();
      const isNewClaim = this.roleClaims.find(
        (roleClaim) => roleClaim.id == dataItem.id
      );
      if (!isNewClaim) {
        this.addRoleClaim(dataItem);
      } else {
        this.editRoleClaim(dataItem);
      }
      this.roleClaimInEdit = undefined;
    },
    cancel() {
      this.roleClaimInEdit = undefined;
    },
    insert() {
      this.roleClaimInEdit = {};
    },
    cloneProduct(product) {
      return Object.assign({}, product);
    },
  },
};
</script>
<style >
.error {
  color: brown;
  margin: auto;
  text-align: left;
  padding: 5px;
}
.needs-validation {
  background: white;
}
</style>